<script>
import WithLogin from '@/components/WithLogin';
import PageWrapper from '@/components/PageWrapper';

export default {
  name: 'App',
  computed: {
    isAuthorized () {
      return this.$store.getters['auth/isAuthorized'];
    },
  },
  watch: {
    isAuthorized: {
      handler () {
        if (this.isAuthorized) {
          this.$store.dispatch('weekends/get', new Date().getFullYear());
          this.$store.dispatch('dict/prefetch');
          this.$store.dispatch('settings/fetch');
        }
      },
      immediate: true,
    },
  },
  render () {
    return (
      <WithLogin>
        <PageWrapper>
          <router-view />
        </PageWrapper>
      </WithLogin>
    );
  },
};
</script>
